// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 779 ? "error" : chunkId) + "." + {"779":"58fb5dd6","936":"f4c8ba99","951":"69f3443f"}[chunkId] + ".css";
};